import { gql } from '@apollo/client';
import {
  IMeetingPlaceLinkToAnyPage,
  MeetingPlaceLinkToAnyPageFragment,
} from './meetingPlaceLinkToAnyPage';

type TextAndImageCardColor = 'Blue' | 'Green' | 'Grey' | 'Red';

export interface ITextAndImageCardBlock {
  blocktype: string;
  id: string;
  title: string;
  cardText: string;
  cardLink?: IMeetingPlaceLinkToAnyPage;
  mediaField: {
    jsonBynderAsset: {
      originalUrl: string;
      thumbnail: string;
    };
    altText: string;
  };
  cardTextOverLay: boolean;
  cardColor: TextAndImageCardColor;
  externalLink?: string;
}

export const TextAndImageCardBlockFragment = gql`
  ${MeetingPlaceLinkToAnyPageFragment}
  fragment TextAndImageCardBlock on BlockTextAndImageCard {
    blocktype: __typename
    sys {
      id
    }
    title
    cardText
    cardLink {
      ...MeetingPlaceLinkToAnyPage
    }
    externalLink
    mediaField {
      jsonBynderAsset
      altText
    }
    cardTextOverlay
    cardColor
  }
`;

export const MeetingPlaceEditorialTagsFragment = gql`
  fragment MeetingPlaceEditorialTags on MeetingPlacePageEditorial {
    contentfulMetadata {
      tags {
        id
      }
    }
  }
`;

export const HomeTextAndImageCardBlockFragment = gql`
  ${MeetingPlaceEditorialTagsFragment}
  fragment HomeTextAndImageCardBlock on BlockTextAndImageCard {
    blocktype: __typename
    sys {
      id
    }
    title
    cardText
    cardLink {
      ...MeetingPlaceLinkToAnyPage
      ... on MeetingPlacePageEditorial {
        ...MeetingPlaceEditorialTags
      }
    }
    externalLink
    mediaField {
      jsonBynderAsset
      altText
    }
    cardTextOverlay
    cardColor
  }
`;
